import PubRightData from './index.vue'
const PubRight = {
  install:(Vue) => {
    Vue.component('PubRight',PubRightData)
  }
}
export default PubRight


// WEBPACK FOOTER //
// ./src/components/public/pubRight/index.js